
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { SingleCourseConent, SwiperCourseContent } from '@xt/client/types/home.d'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop() label: string
  @Prop() tabs: {
    key: number
    label: string
    content: SingleCourseConent | SwiperCourseContent
  }[]
  @Prop({ default: 0 }) current: number

  @Ref()
  tabActive: HTMLDivElement

  clickDisable(index) {
    return this.tabs[index].content.list.length === 0
  }

  changeTabs(index) {
    if (this.current === index) return

    // 当前点击tabs的list为空时不跳转
    if (this.tabs[index].content.list.length === 0) {
      this.$msg('敬请期待～', 'info')
      return
    }

    let offset = this.tabActive.offsetLeft // 获取 activeTabs 的left值

    if (this.current > index) {
      for (let i = this.current - 1; i >= index; i--) {
        offset = offset - Math.floor(this.$refs[`tab-${i}`]![0].offsetWidth) - 8
      }
    } else {
      for (let i = this.current; i < index; i++) {
        offset = offset + Math.floor(this.$refs[`tab-${i}`]![0].offsetWidth) + 8
      }
    }

    this.tabActive.style.left = `${offset}px`

    this.$emit('changeTabs', index)
  }

  initLabelPosition() {
    let offset = this.tabActive.offsetLeft
    for (let i = 0; i < this.current; i++) {
      offset = offset + Math.floor(this.$refs[`tab-${i}`]![0].offsetWidth) + 8
    }
    this.tabActive.style.left = `${offset}px`
  }

  created(): void {}

  mounted(): void {
    this.initLabelPosition()
  }

  updated(): void {}

  destroyed(): void {}
}
